import {Navigate} from 'react-router'
import {lazy, Suspense} from 'react'
import {AppShell} from './app-shell.jsx'
import {RequireAuth, RequireRole} from './auth/require-role.jsx'
import {AuthScreen} from './screens/auth/auth.jsx'
import {Dashboard} from './screens/dashboard/dashboard.jsx'
import {MetricHistory} from './screens/metric-history/metric-history.jsx'
import {Scenarios} from './screens/scenarios/scenarios.jsx'
import {ScenarioDetail} from './screens/scenario-detail/scenario-detail.jsx'
import {Tasks} from './screens/tasks/tasks.jsx'
import {TaskDetail} from './screens/task-detail/task-detail.jsx'
import {IssueReport} from './screens/issue-report/issue-report.jsx'
import {Notifications} from './screens/notifications/notifications.jsx'
import {Profile} from './screens/profile/profile.jsx'

const AdminUsers = lazy(() =>
    import('./screens/admin/users/users.jsx').then(m => ({default: m.AdminUsers}))
)
const AdminScenarios = lazy(() =>
    import('./screens/admin/scenarios/scenarios-admin.jsx').then(m => ({default: m.AdminScenarios}))
)
const AdminScenarioForm = lazy(() =>
    import('./screens/admin/scenarios/scenario-form.jsx').then(m => ({default: m.AdminScenarioForm}))
)
const AdminTasks = lazy(() =>
    import('./screens/admin/tasks/tasks-admin.jsx').then(m => ({default: m.AdminTasks}))
)
const AdminControls = lazy(() =>
    import('./screens/admin/controls/controls-admin.jsx').then(m => ({default: m.AdminControls}))
)
const AdminControlForm = lazy(() =>
    import('./screens/admin/controls/control-form.jsx').then(m => ({default: m.AdminControlForm}))
)
const AdminControlDetail = lazy(() =>
    import('./screens/admin/controls/control-detail.jsx').then(m => ({default: m.AdminControlDetail}))
)
const AdminReadings = lazy(() =>
    import('./screens/admin/readings/readings-admin.jsx').then(m => ({default: m.AdminReadings}))
)
const AdminDeviceReadings = lazy(() =>
    import('./screens/admin/readings/device-readings.jsx').then(m => ({default: m.AdminDeviceReadings}))
)
const AdminAuditLog = lazy(() =>
    import('./screens/admin/audit-log/audit-log.jsx').then(m => ({default: m.AdminAuditLog}))
)

function withAuth(node) {
    return <RequireAuth>{node}</RequireAuth>
}

function withAdmin(node) {
    return <RequireRole admin>{node}</RequireRole>
}

function adminLazy(node) {
    return withAdmin(<Suspense fallback={null}>{node}</Suspense>)
}

export const routes = [
    {
        element: <AppShell/>,
        children: [
            {path: '/auth', element: <AuthScreen/>},
            {path: '/', element: withAuth(<Dashboard/>)},
            {path: '/metrics/:metricId', element: withAuth(<MetricHistory/>)},
            {path: '/scenarios', element: withAdmin(<Scenarios/>)},
            {path: '/scenarios/:id', element: withAdmin(<ScenarioDetail/>)},
            {path: '/tasks', element: withAuth(<Tasks/>)},
            {path: '/tasks/:id', element: withAuth(<TaskDetail/>)},
            {path: '/issues/new', element: withAuth(<IssueReport/>)},
            {path: '/notifications', element: withAuth(<Notifications/>)},
            {path: '/profile', element: withAuth(<Profile/>)},
            {path: '/admin/users', element: adminLazy(<AdminUsers/>)},
            {path: '/admin/scenarios', element: adminLazy(<AdminScenarios/>)},
            {path: '/admin/scenarios/new', element: adminLazy(<AdminScenarioForm mode="create"/>)},
            {path: '/admin/scenarios/:id/edit', element: adminLazy(<AdminScenarioForm mode="edit"/>)},
            {path: '/admin/tasks', element: adminLazy(<AdminTasks/>)},
            {path: '/admin/controls', element: adminLazy(<AdminControls/>)},
            {path: '/admin/controls/new', element: adminLazy(<AdminControlForm mode="create"/>)},
            {path: '/admin/controls/:id', element: adminLazy(<AdminControlDetail/>)},
            {path: '/admin/controls/:id/edit', element: adminLazy(<AdminControlForm mode="edit"/>)},
            {path: '/admin/readings', element: adminLazy(<AdminReadings/>)},
            {path: '/admin/readings/:device', element: adminLazy(<AdminDeviceReadings/>)},
            {path: '/admin/audit', element: adminLazy(<AdminAuditLog/>)},
            {path: '*', element: <Navigate to="/" replace/>}
        ]
    }
]
